import computed from './computed'
import data from './data'
import components from './components'
import mounted from './mounted'

export default {
  computed,
  data,
  mounted,
  components,
  resourcePath: '/v1/dweller/bikes'
}



// WEBPACK FOOTER //
// ./src/app/dweller/bike/resources/index.js